import { PencilSimpleLine } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { Button, IButtonProps } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { IPartBom, IPartBomItem } from 'partBoms/types';
import { Color } from 'theme/enums';

import { UpsertItem } from './UpsertItem';

interface IProps extends IButtonProps {
  partBom: IPartBom;
  partBomItem: IPartBomItem;
  buttonElement?: ReactElement;
}

export const EditItemButton = ({ partBom, partBomItem, buttonElement, ...rest }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const queryClient = useQueryClient();

  const { t } = useTranslation();

  const { updateRows } = useAgGridClientTableContext();

  const handleOnClose = () => setIsOpen(false);

  const onSubmitSuccess = (partBomItem: IPartBomItem) => {
    updateRows({
      update: [partBomItem],
    });

    queryClient.invalidateQueries(['partBomItems']);
  };

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelEditPartBomItem')}
        color={Color.PRIMARY}
        startDecorator={<PencilSimpleLine />}
        onClick={() => setIsOpen(true)}
        {...rest}
      />
    );
  }, [buttonElement, rest, t]);

  return (
    <>
      {button}

      <UpsertItem
        isOpen={isOpen}
        onClose={handleOnClose}
        partBom={partBom}
        partBomItem={partBomItem}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
